<template>
    <table class="table table-striped table-bordered table-hover">
    	<thead>
        <tr>
            <th>Event#</th>
            <th>Event</th>
            <th class="hidden-xs">Ind / Relay</th>
            <th>Gender</th>
            <th class="hidden-xs">Heats / Finals</th>
            <th class="hidden-xs">Type</th>
            <th class="text-right">Entry Fee</th>
            <th class="text-center">Allow Entries</th>
        </tr>
    </thead>
    <tbody>
		<tr v-for="(event, index) in meetEvents">
            <td>{{ event.event_number }}</td>
            <td>{{ event.event }}</td>
            <td class="hidden-xs">{{event.individual_relay}}</td>
            <td>{{ event.gender }}</td>
            <td class="hidden-xs">{{event.round}}</td>
            <td class="hidden-xs">{{event.type}}</td>
            <td class="text-right">
		        <div class="input-group">
		            <span class="input-group-addon">£</span>
		            <input type="text" class="form-control select-on-enter" v-model="event.entry_fee" v-on:change="updateEvent(index)"/>
		        </div>
            </td>
            <td class="text-center">
            	<span class="glyphicon" v-bind:class="{ 'text-success glyphicon-ok' : event.entries_enabled, 'text-danger glyphicon-remove' : !event.entries_enabled }" aria-hidden="true" v-on:click="toggleAllowEntries(index)"></span>
            </td>
        </tr>
    </tbody>
    </table>
</template>



<script>

import { DatePicker, Message, Icon, Tooltip, Loading } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);


export default {
	components: { DatePicker, Message, Tooltip, Icon, Loading },
	props: ['meet_id'],
	data: function () {
		return {
			meetId: this.meet_id,
			meetEvents: [],
			loading: false
		}
	},
	computed: {

	},
	mounted() {
		console.log('MeetEventList component mounted.');
		this.getMeetEvents();
	},
    methods: {
    	getMeetEvents() {
			// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
            axios.get('/api/v1/meet/' + this.meet_id + '/events').then((response) => {
				// this.loadingInstance.close();
                console.log(response.data);
            	this.meetEvents = response.data;
            }).catch((error) => {
				// this.loadingInstance.close();
				this.$message({message: 'There was a problem loading events.', type: 'error'});
            });
        },
    	updateEvent(eventIndex) {
    		var theEvent = this.meetEvents[eventIndex];
            console.log('Updating event');
			// this.loadingInstance = Loading.service({text: "Updating server... please wait"});
			axios.put('/api/v1/meet_event', theEvent
				).then((response) => {
				console.log(response.data);
				// this.loadingInstance.close();
				this.meetEvents[eventIndex] = response.data;
				this.$message({message: 'The event was updated successfully', type: 'success'});
			}).catch((error) => {
				console.log(error);
				// this.loadingInstance.close();
				this.handleHTTPError(error);
				this.$message({message: 'There was a problem updating the event - please try again', type: 'error'});
			});
    	},
    	toggleAllowEntries(eventIndex) {
    		console.log('Toggling allow entries');
    		console.log(this.meetEvents[eventIndex]);
    		this.meetEvents[eventIndex].entries_enabled =  ! this.meetEvents[eventIndex].entries_enabled;
    		this.updateEvent(eventIndex);
    	},
		handleHTTPError(error) {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response.data); // Error message
					console.log(error.response.status);
					console.log(error.response.headers);
					this.$message({message: 'Error: ' + error.response.data, type: 'error'});
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
					this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
					this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
				}
				console.log(error.config);
		},
	    }
}
</script>
